import React, { useEffect, useContext, useState } from 'react';
import { Form, InputGroup } from 'react-bootstrap';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Panel from 'components/common/panel/panel';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import SiteContext from 'components/shared/siteContext/siteContext';
import useForm from 'hooks/form';

export default function EmployeesDetailsPage(props) {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);
  const { setFormRef, submitForm, renderFormValidationMessage } = useForm({ protect: true });

  const [data, setData] = useState({
    id: 1,
    color: '#9b2caf',
    name: 'John Smith',
    firstName: 'John',
    lastName: 'Smith',
    middleInitial: 'A',
    initials: 'JS',
    employeeNumber: 4,
    altEmployeeNumber: 12,
    dailyHoursWorked: 4,
    weeklyHoursWorked: 21,
    isClockedIn: true,
    imageURL: 'http://webapplayers.com/inspinia_admin-v2.8/img/a4.jpg',
    jobs: [
      {
        id: 1,
        name: 'Server',
        departmentId: 1,
        departmentName: 'Server',
        rate: 2.63,
      },
      {
        id: 2,
        name: 'Training',
        departmentId: 1,
        departmentName: 'Server',
        rate: 8,
      },
    ],
  });

  useEffect(() => {
    setAppArea(AppContext.Areas.Menus, 'Edit Employee');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'Employees', href: '/Employees' }, { name: 'Edit Employee', selected: true }]);
  }, []);

  const handleCancelClicked = () => {
    props.history.goBack();
  };

  const handleSaveClicked = submitForm(async (cancelSubmit) => {
    props.history.push('/Employees');
  });

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          <SiteContext.Button hierarchyId={141} readOnly />
          <div className='flex-grow-1 d-flex justify-content-end'>
            <Inputs.Button variant='default' onClick={handleCancelClicked} iconClass='icons8-undo' label='Cancel' />
            <Inputs.Button variant='success' onClick={handleSaveClicked} iconClass='icons8-save' label='Save' />
          </div>
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Form ref={setFormRef} noValidate>
              <PersonalInformationPanel data={data} setData={setData} />
              <UserRecordPanel data={data} setData={setData} />
              <JobsPanel data={data} setData={setData} />
              <div className='mb-4'>
                {renderFormValidationMessage()}
                <Inputs.Button variant='default' onClick={handleCancelClicked} iconClass='icons8-undo' label='Cancel' />
                <Inputs.Button variant='success' onClick={handleSaveClicked} iconClass='icons8-save' label='Save' />
              </div>
            </Form>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function PersonalInformationPanel(props) {
  const data = props.data || {};
  const setData = props.setData;

  const updateField = (field, value) => {
    let newData = { ...data };
    newData[field] = value;
    setData(newData);
  };

  return (
    <Panel>
      <Panel.Header>
        Personal Information
      </Panel.Header>
      <Panel.Body>
        <Form.Row>
          <Form.Group className='col-5'>
            <Form.Label required>First Name</Form.Label>
            <Inputs.Text placeholder='First Name' value={data.firstName} onValueChange={(v) => updateField('firstName', v)} required />
          </Form.Group>
          <Form.Group className='col-5'>
            <Form.Label required>Last Name</Form.Label>
            <Inputs.Text placeholder='Last Name' value={data.lastName} onValueChange={(v) => updateField('lastName', v)} required />
          </Form.Group>
          <Form.Group className='col-2'>
            <Form.Label>Middle Initial</Form.Label>
            <Inputs.Text placeholder='MI' value={data.middleInitial} onValueChange={(v) => updateField('middleInitial', v)} maxLength={1} />
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group className='col-4'>
            <Form.Label>Date of Birth</Form.Label>
            <Inputs.Date placeholder='Date of Birth' value={data.dob} onValueChange={(v) => updateField('dob', v)} />
          </Form.Group>
          <Form.Group className='col-4'>
            <Form.Label>Gender</Form.Label>
            <Inputs.Select placeholder='Gender' value={data.gender} onValueChange={(v) => updateField('gender', v)}>
              <option>Male</option>
              <option>Female</option>
            </Inputs.Select>
          </Form.Group>
          <Form.Group className='col-4'>
            <Form.Label>Marital Status</Form.Label>
            <Inputs.Select placeholder='Gender' value={data.maritalStatus} onValueChange={(v) => updateField('maritalStatus', v)}>
              <option>Single</option>
              <option>Married</option>
              <option>Unknown</option>
            </Inputs.Select>
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group className='col-6'>
            <Form.Label>Phone</Form.Label>
            <Inputs.Text placeholder='Phone' value={data.phoneNumber} onValueChange={(v) => updateField('phoneNumber', v)} />
          </Form.Group>
          <Form.Group className='col-6'>
            <Form.Label>Alt. Phone</Form.Label>
            <Inputs.Text placeholder='Alt. Phone' value={data.altPhoneNumber} onValueChange={(v) => updateField('altPhoneNumber', v)} />
          </Form.Group>
        </Form.Row>

        <Form.Group>
          <Form.Label>Address 1</Form.Label>
          <Inputs.Text placeholder='Address 1' value={data.address} onValueChange={(v) => updateField('address', v)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Address 2</Form.Label>
          <Inputs.Text placeholder='Address 2' value={data.address2} onValueChange={(v) => updateField('address2', v)} />
        </Form.Group>
        <Form.Group>
          <Form.Label>Address 3</Form.Label>
          <Inputs.Text placeholder='Address 3' value={data.address3} onValueChange={(v) => updateField('address3', v)} />
        </Form.Group>
        <Form.Row>
          <Form.Group className='col-md-6'>
            <Form.Label>City</Form.Label>
            <Inputs.Text placeholder='City' value={data.city} onValueChange={(v) => updateField('city', v)} />
          </Form.Group>
          <Form.Group className='col-md-4'>
            <Form.Label>State</Form.Label>
            <Inputs.Text placeholder='State' value={data.state} onValueChange={(v) => updateField('state', v)} />
          </Form.Group>
          <Form.Group className='col-md-2'>
            <Form.Label>Zip</Form.Label>
            <Inputs.Text placeholder='Zip' value={data.zip} onValueChange={(v) => updateField('zip', v)} />
          </Form.Group>
        </Form.Row>
      </Panel.Body>
    </Panel>
  );
}

function UserRecordPanel(props) {
  const data = props.data || {};
  const setData = props.setData;

  const updateField = (field, value) => {
    let newData = { ...data };
    newData[field] = value;
    setData(newData);
  };

  return (
    <Panel>
      <Panel.Header>
        User Record
      </Panel.Header>
      <Panel.Body>
        <Form.Row>
          <Form.Group className='col-6'>
            <Form.Label required>POS User</Form.Label>
            <div className='mx-2 mb-2 mt-1'>
              <Inputs.Checkbox label='Is POS User' />
            </div>
          </Form.Group>
          <Form.Group className='col-6'>
            <Form.Label required>POS User Type</Form.Label>
            <Inputs.Select placeholder='User Type' value={data.posUserType} onValueChange={(v) => updateField('posUserType', v)}>
              <option>MANAGER</option>
            </Inputs.Select>
          </Form.Group>
        </Form.Row>

        <Form.Row>
          <Form.Group className='col-4'>
            <Form.Label required>Employee Number</Form.Label>
            <Inputs.Integer placeholder='Employee Number' value='' required />
          </Form.Group>
          <Form.Group className='col-4'>
            <Form.Label>Alt. Number</Form.Label>
            <Inputs.Integer placeholder='Alt. Employee Number' value='' />
          </Form.Group>
          <Form.Group className='col-4'>
            <Form.Label required>MAG Card Number</Form.Label>
            <Inputs.Integer placeholder='MAG Card Number' value={data.magCardNumber} onValueChange={(v) => updateField('magCardNumber', v)} />
          </Form.Group>
        </Form.Row>
      </Panel.Body>
    </Panel>
  );
}

function JobsPanel(props) {
  const data = props.data || {};
  const setData = props.setData;
  const jobs = data.jobs || [];

  const setJob = (newJobData, index) => {
    let newData = { ...data };
    newData.jobs[index] = newJobData;
    setData(newData);
  };

  const handleAddJob = () => {
    let newData = { ...data };
    newData.jobs.push({
      id: null,
      departmentId: null,
      rate: null,
      editable: true,
    });
    setData(newData);
  };

  const handleDeleteJob = (index) => {
    let newData = { ...data };
    newData.jobs.splice(index, 1);
    setData(newData);
  }

  return (
    <Panel>
      <Panel.Header>
        Jobs &amp; Rates
      </Panel.Header>
      <Panel.Body>
        <ul className='list-group list-group-flush'>
          <li className='list-group-item'>
            <div className='row'>
              <div className='col-4'>
                <div className='mx-2 text-thick'>Department</div>
              </div>
              <div className='col-4'>
                <div className='mx-2 text-thick'>Job</div>
              </div>
              <div className='col-4'>
                <div className='text-thick'>Rate</div>
              </div>
            </div>
          </li>
          {jobs.map((job, index) => <JobsPanelRow job={job} setJob={(j) => setJob(j, index)} onDeleteJob={() => handleDeleteJob(index)} key={index} />)}
        </ul>
      </Panel.Body>
      <Panel.Footer>
        <Inputs.Button label='Add Job' iconClass='icons8-plus-math' variant='primary' onClick={handleAddJob} />
      </Panel.Footer>
    </Panel>
  );
}

function JobsPanelRow(props) {
  const job = props.job || {};
  const setJob = props.setJob;
  const handleDeleteJob = props.onDeleteJob;

  const handleDepartmentChange = (departmentId) => {
    departmentId = parseInt(departmentId);
    const firstJob = jobList.find(j => j.departmentId === departmentId);
    setJob({
      ...job,
      departmentId: parseInt(departmentId),
      id: firstJob ? firstJob.id : null,
    });
  };

  const handleJobChange = (jobId) => {
    setJob({ ...job, id: parseInt(jobId) });
  };

  const renderDepartments = () => {
    return (
      <Inputs.Select value={job.departmentId} onValueChange={handleDepartmentChange} placeholder='Please select department' required>
        {departmentList.map((d) => <Inputs.Option value={d.id} label={d.name} key={d.id} />)}
      </Inputs.Select>
    );
  };

  const renderJobs = () => {
    if (!job.departmentId) {
      //return <div className='m-2 opacity-60 font-italic'>Select a department</div>;
      return <Inputs.Select placeholder='Please select job' required />;
    }
    else {
      return (
        <Inputs.Select value={job.id} onValueChange={handleJobChange} placeholder='Please select job' required>
          {jobList.filter((j) => j.departmentId === job.departmentId).map((j) => <Inputs.Option value={j.id} label={j.name} key={j.id} />)}
        </Inputs.Select>
      );
    }
  };

  if (job.editable) {
    return (
      <li className='list-group-item'>
        <div className='row'>
          <div className='col-4'>
            {renderDepartments()}
          </div>
          <div className='col-4'>
            {renderJobs()}
          </div>
          <div className='col-3'>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>$</InputGroup.Text>
              </InputGroup.Prepend>
              <Inputs.Float placeholder='0.000' precision='3' value={job.rate ? job.rate.toFixed(3) : null} />
            </InputGroup>
          </div>
          <div className='col-1 text-right'>
            <Inputs.Button variant='danger' iconClass='icons8-trash' circle onClick={handleDeleteJob} />
          </div>
        </div>
      </li>
    );
  }
  else {
    return (
      <li className='list-group-item'>
        <div className='row'>
          <div className='col-4'>
            <div className='m-2'>{job.departmentName}</div>
          </div>
          <div className='col-4'>
            <div className='m-2'>{job.name}</div>
          </div>
          <div className='col-3'>
            <InputGroup>
              <InputGroup.Prepend>
                <InputGroup.Text>$</InputGroup.Text>
              </InputGroup.Prepend>
              <Inputs.Float placeholder='0.000' precision='3' value={job.rate ? job.rate.toFixed(3) : null} />
            </InputGroup>
          </div>
          <div className='col-1 text-right'>
            <Inputs.Button variant='danger' iconClass='icons8-trash' circle onClick={handleDeleteJob} />
          </div>
        </div>
      </li>
    );
  }
}



const departmentList = [
  {
    id: 1,
    name: 'Line Cook',
  },
  {
    id: 2,
    name: 'Server',
  },
  {
    id: 3,
    name: 'Bar',
  },
  {
    id: 4,
    name: 'Host/Door',
  },
  {
    id: 5,
    name: 'Maintenance',
  },
];

const jobList = [
  {
    id: 1,
    name: 'Dishwasher',
    departmentId: 1,
  },
  {
    id: 2,
    name: 'Line Cook',
    departmentId: 1,
  },
  {
    id: 3,
    name: 'Prep Cook',
    departmentId: 1,
  },
  {
    id: 4,
    name: 'Manager',
    departmentId: 1,
  },
  {
    id: 5,
    name: 'Server',
    departmentId: 2,
  },
  {
    id: 6,
    name: 'Training',
    departmentId: 2,
  },
  {
    id: 7,
    name: 'Manager',
    departmentId: 2,
  },
  {
    id: 8,
    name: 'Bartender',
    departmentId: 3,
  },
  {
    id: 9,
    name: 'Bartender Training',
    departmentId: 3,
  },
  {
    id: 10,
    name: 'Bar Back',
    departmentId: 3,
  },
  {
    id: 11,
    name: 'Host',
    departmentId: 4,
  },
  {
    id: 12,
    name: 'Door',
    departmentId: 4,
  },
  {
    id: 13,
    name: 'Maintenance',
    departmentId: 5,
  },
];